var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { class: _vm.containerCss, attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { dark: _vm.dark, color: _vm.colour, dense: _vm.dense } },
        [
          _c("v-toolbar-title", { class: _vm.textColourCss }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm._t("toolbarItems"),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    fab: "",
                    color: _vm.colour,
                    dark: _vm.dark,
                  },
                  on: { click: _vm.closeClickHandler },
                },
                [
                  _c("v-icon", { class: _vm.textColourCss }, [
                    _vm._v("mdi-close"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass: "y_scroll",
          style: _vm.calcHeight,
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            {
              class: _vm.contentCss,
              style: _vm.calcWidth,
              attrs: { cols: "12" },
            },
            [_vm._t("contents")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }